// Mappings from shortened database strings
// to human readable strings or images
import fiveStagesIcon from '../static/img/icons/class_type_icons/five_stages_icon.svg';
// import fiftytwomovesIcon from '../static/img/icons/class_type_icons/NiaPlaceholderCertIcon.png';
import classicNia from '../static/img/icons/class_type_icons/classic_nia.png';
import moveitIcon from '../static/img/icons/class_type_icons/move_it_icon.svg';
import movingtohealIcon from '../static/img/icons/class_type_icons/moving_to_heal_icon.svg';
import freedanceIcon from '../static/img/icons/class_type_icons/freedance_icon.svg';
import floorplayIcon from '../static/img/icons/class_type_icons/floorplay_icon.svg';
import whitebeltIcon from '../static/img/icons/class_type_icons/white_belt_icon.svg';
import greenbeltIcon from '../static/img/icons/class_type_icons/green_belt_icon.svg';
import bluebeltIcon from '../static/img/icons/class_type_icons/blue_belt_icon.svg';
import brownbeltIcon from '../static/img/icons/class_type_icons/brown_belt_icon.svg';
import blackbeltIcon from '../static/img/icons/class_type_icons/black_belt_icon.svg';
import firstdegreeblackbeltIcon from '../static/img/icons/class_type_icons/first_degree_icon.svg';
import seconddegreeblackbeltIcon from '../static/img/icons/class_type_icons/second_degree_icon.svg';

const classTypeMap = {
  nia: 'Classic Nia',
  '5stages': '5 Stages',
  '52moves': '52 Moves',
  moveit: 'Move It',
  m2h: 'Moving to Heal',
  freedance: 'FreeDance',
  floorplay: 'FloorPlay',
};

const classIconMap = {
  nia: classicNia,
  '5stages': fiveStagesIcon,
  '52moves': moveitIcon,
  moveit: moveitIcon,
  m2h: movingtohealIcon,
  freedance: freedanceIcon,
  floorplay: floorplayIcon,
  'white-belt': whitebeltIcon,
  'green-belt': greenbeltIcon,
  'blue-belt': bluebeltIcon,
  'brown-belt': brownbeltIcon,
  'black-belt': blackbeltIcon,
  'first-degree-black-belt': firstdegreeblackbeltIcon,
  'second-degree-black-belt': seconddegreeblackbeltIcon,
};

const orderings = [
  { code: 'time', name: 'Time' },
  { code: 'location', name: 'Location' },
];

const trainingOrderings = [
  { code: 'time', name: 'Date' },
  { code: 'location', name: 'Location' },
];

const attendanceTypes = [
  { code: 'online', name: 'Online' },
  { code: 'inperson', name: 'In-Person' },
  { code: 'both', name: 'Both' },
];

const trainingAttendanceTypes = [
  { code: 'online', name: 'Online' },
  { code: 'inperson', name: 'In-Person' },
];

const trainingTypeMap = {
  'white-belt': 0,
  'green-belt': 1,
  'blue-belt': 2,
  'brown-belt': 3,
  'black-belt': 4,
  'first-degree-black-belt': 5,
  'second-degree-black-belt': 6,
};

const trainingSearchTypeMap = [
  '',
  'White Belt',
  'Green Belt',
  'Blue Belt',
  'Brown Belt',
  'Black Belt',
  'First Degree Black Belt',
  'Second Degree Black Belt',
  // '52 Moves',
  'Moving to Heal',
  'Freedance',
  'Five Stages',
  'Art of Teaching',
  'Floorplay',
  'The Body\'s Way',
];

const classTypes = [
  { code: 'any', name: 'Any Class Type' },
  { code: 'nia', name: 'Classic Nia' },
  { code: '5stages', name: '5 Stages' },
  // {  code: '52moves',  name: '52 Moves' },
  { code: 'moveit', name: 'Move It' },
  { code: 'm2h', name: 'Moving To Heal' },
  { code: 'freedance', name: 'FreeDance' },
  { code: 'floorplay', name: 'FloorPlay' },
];

const days = [
  'Any Day',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const dayNumbers = {
  0: 'Monday',
  1: 'Tuesday',
  2: 'Wednesday',
  3: 'Thursday',
  4: 'Friday',
  5: 'Saturday',
  6: 'Sunday',
};

const numberDays = {
  Monday: 0,
  Tuesday: 1,
  Wednesday: 2,
  Thursday: 3,
  Friday: 4,
  Saturday: 5,
  Sunday: 6,
};

const startTimes = [
  'Any Time',
  '12:00 AM',
  '1:00 AM',
  '2:00 AM',
  '3:00 AM',
  '4:00 AM',
  '5:00 AM',
  '6:00 AM',
  '7:00 AM',
  '8:00 AM',
  '9:00 AM',
  '10:00 AM',
  '11:00 AM',
  '12:00 PM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
  '4:00 PM',
  '5:00 PM',
  '6:00 PM',
  '7:00 PM',
  '8:00 PM',
  '9:00 PM',
  '10:00 PM',
  '11:00 PM',
];

const endTimes = [
  'Any Time',
  '12:59 AM',
  '1:59 AM',
  '2:59 AM',
  '3:59 AM',
  '4:59 AM',
  '5:59 AM',
  '6:59 AM',
  '7:59 AM',
  '8:59 AM',
  '9:59 AM',
  '10:59 AM',
  '11:59 AM',
  '12:59 PM',
  '1:59 PM',
  '2:59 PM',
  '3:59 PM',
  '4:59 PM',
  '5:59 PM',
  '6:59 PM',
  '7:59 PM',
  '8:59 PM',
  '9:59 PM',
  '10:59 PM',
  '11:59 PM',
];

const timezones = [
  // US/CANADA
  {
    name: 'US/CANADA',
    code: '',
  },
  {
    name: 'Pacific Time - US & Canada',
    code: 'America/Los_Angeles',
  },
  {
    name: 'Mountain Time - US & Canada',
    code: 'America/Denver',
  },
  {
    name: 'Central Time - US & Canada',
    code: 'America/Chicago',
  },
  {
    name: 'Eastern Time - US & Canada',
    code: 'America/New_York',
  },
  {
    name: 'Yukon Time',
    code: 'America/Dawson',
  },
  {
    name: 'Alaska Time',
    code: 'America/Anchorage',
  },
  {
    name: 'Arizona Time',
    code: 'America/Phoenix',
  },
  {
    name: 'Newfoundland Time',
    code: 'Canada/Newfoundland',
  },
  {
    name: 'Hawaiian Time',
    code: 'US/Hawaii',
  },
  // AMERICA
  {
    name: 'AMERICA',
    code: '',
  },
  {
    name: 'America/Adak',
    code: 'America/Adak',
  },
  {
    name: 'Buenos Aires Time',
    code: 'America/Argentina/Buenos_Aires',
  },
  {
    name: 'Asuncion Time',
    code: 'America/Asuncion',
  },
  {
    name: 'Bogota, Jamaica, Lima Time',
    code: 'America/Bogota',
  },
  {
    name: 'America/Campo Grande',
    code: 'America/Campo_Grande',
  },
  {
    name: 'Caracas Time',
    code: 'America/Caracas',
  },
  {
    name: 'America/Godthab',
    code: 'America/Godthab',
  },
  {
    name: 'Atlantic Time',
    code: 'Canada/Atlantic',
  },
  {
    name: 'Saskatchewan, Guatemala, Costa Rica Time',
    code: 'America/Guatemala',
  },
  {
    name: 'America/Havana',
    code: 'America/Havana',
  },
  {
    name: 'Mexico City Time',
    code: 'America/Mexico_City',
  },
  {
    name: 'Montevideo Time',
    code: 'America/Montevideo',
  },
  {
    name: 'America/Miquelon',
    code: 'America/Miquelon',
  },
  {
    name: 'America/Noronha',
    code: 'America/Noronha',
  },
  {
    name: 'Santiago Time',
    code: 'America/Santiago',
  },
  {
    name: 'America/Santa Isabel',
    code: 'America/Santa_Isabel',
  },
  {
    name: 'Atlantic Standard Time',
    code: 'America/Puerto_Rico',
  },
  {
    name: 'Brasilia Time',
    code: 'America/Fortaleza',
  },
  // AFRICA
  {
    name: 'AFRICA',
    code: '',
  },
  {
    name: 'Africa/Cairo',
    code: 'Africa/Cairo',
  },
  {
    name: 'Central Africa Time',
    code: 'Africa/Gaborone',
  },
  {
    name: 'West Africa Time',
    code: 'Africa/Algiers',
  },
  {
    name: 'Africa/Windhoek',
    code: 'Africa/Windhoek',
  },
  // ASIA
  {
    name: 'ASIA',
    code: '',
  },
  {
    name: 'Jordan Time',
    code: 'Europe/Bucharest',
  },
  {
    name: 'Baghdad, East Africa Time',
    code: 'Asia/Baghdad',
  },
  {
    name: 'Asia/Baku',
    code: 'Asia/Baku',
  },
  {
    name: 'Lebanon Time',
    code: 'Asia/Beirut',
  },
  {
    name: 'Syria Time',
    code: 'Asia/Damascus',
  },
  {
    name: 'Asia/Dhaka',
    code: 'Asia/Dhaka',
  },
  {
    name: 'Dubai Time',
    code: 'Asia/Dubai',
  },
  {
    name: 'Asia/Gaza',
    code: 'Asia/Gaza',
  },
  {
    name: 'Asia/Irkutsk',
    code: 'Asia/Irkutsk',
  },
  {
    name: 'Indochina Time',
    code: 'Asia/Bangkok',
  },
  {
    name: 'Israel Time',
    code: 'Asia/Jerusalem',
  },
  {
    name: 'Kabul Time',
    code: 'Asia/Kabul',
  },
  {
    name: 'Pacific/Majuro',
    code: 'Pacific/Majuro',
  },
  {
    name: 'Pakistan, Maldives',
    code: 'Indian/Maldives',
  },
  {
    name: 'Kathmandu Time',
    code: 'Asia/Kathmandu',
  },
  {
    name: 'India, Sri Lanka Time',
    code: 'Asia/Kolkata',
  },
  {
    name: 'Krasnoyarsk Time',
    code: 'Asia/Krasnoyarsk',
  },
  {
    name: 'Asia/Omnsk',
    code: 'Asia/Omsk',
  },
  {
    name: 'Asia/Rangoon',
    code: 'Asia/Rangoon',
  },
  {
    name: 'China, Singapore, Perth',
    code: 'Australia/Perth',
  },
  {
    name: 'Tehran Time',
    code: 'Asia/Tehran',
  },
  {
    name: 'Japan, Korea Time',
    code: 'Asia/Tokyo',
  },
  {
    name: 'Asia/Vladivostok',
    code: 'Asia/Vladivostok',
  },
  {
    name: 'Asia/Yakutsk',
    code: 'Asia/Yakutsk',
  },
  {
    name: 'Yekaterinburg Time',
    code: 'Asia/Yekaterinburg',
  },
  {
    name: 'Asia/Yerevan',
    code: 'Asia/Yerevan',
  },
  // ATLANTIC
  {
    name: 'ATLANTIC',
    code: '',
  },
  {
    name: 'Azores Time',
    code: 'Atlantic/Azores',
  },
  {
    name: 'Cape Verde Time',
    code: 'Atlantic/Cape_Verde',
  },
  // AUSTRALIA
  {
    name: 'AUSTRALIA',
    code: '',
  },
  {
    name: 'Adelaide Time',
    code: 'Australia/Adelaide',
  },
  {
    name: 'Brisbane Time',
    code: 'Australia/Brisbane',
  },
  {
    name: 'Australia/Darwin',
    code: 'Australia/Darwin',
  },
  {
    name: 'Australia/Eucla',
    code: 'Australia/Eucla',
  },
  {
    name: 'Australia/Lord Howe',
    code: 'Australia/Lord_Howe',
  },
  {
    name: 'Australia/Perth',
    code: 'Australia/Perth',
  },
  {
    name: 'Sydney, Melbourne Time',
    code: 'Australia/Sydney',
  },
  // UTC
  {
    name: 'UTC',
    code: '',
  },
  {
    name: 'UTC Time',
    code: 'UTC',
  },
  // EUROPE
  {
    name: 'EUROPE',
    code: '',
  },
  {
    name: 'Central European Time',
    code: 'Europe/Paris',
  },
  {
    name: 'Eastern European Time',
    code: 'Europe/Sofia',
  },
  {
    name: 'UK, Ireland, Lisbon Time',
    code: 'Europe/Lisbon',
  },
  {
    name: 'Minsk Time',
    code: 'Europe/Minsk',
  },
  {
    name: 'Moscow Time',
    code: 'Europe/Moscow',
  },
  {
    name: 'Turkey Time',
    code: 'Europe/Istanbul',
  },
  // PACIFIC
  {
    name: 'PACIFIC',
    code: '',
  },
  {
    name: 'Pacific/Apia',
    code: 'Pacific/Apia',
  },
  {
    name: 'Auckland Time',
    code: 'Pacific/Auckland',
  },
  {
    name: 'Pacific/Chatham',
    code: 'Pacific/Chatham',
  },
  {
    name: 'Pacific/Easter',
    code: 'Pacific/Easter',
  },
  {
    name: 'Pacific/Fiji',
    code: 'Pacific/Fiji',
  },
  {
    name: 'Pacific/Gambier',
    code: 'Pacific/Gambier',
  },
  {
    name: 'Pacific/Kiritimati',
    code: 'Pacific/Kiritimati',
  },
  {
    name: 'Pacific/Majuro',
    code: 'Pacific/Majuro',
  },
  {
    name: 'Pacific/Marquesas',
    code: 'Pacific/Marquesas',
  },
  {
    name: 'Pacific/Norfolk',
    code: 'Pacific/Norfolk',
  },
  {
    name: 'Pacific/Noumea',
    code: 'Pacific/Noumea',
  },
  {
    name: 'Pacific/Pago Pago',
    code: 'Pacific/Pago_Pago',
  },
  {
    name: 'Pacific/Pitcairn',
    code: 'Pacific/Pitcairn',
  },
  {
    name: 'Pacific/Tarawa',
    code: 'Pacific/Tarawa',
  },
  {
    name: 'Pacific/Tongatapu',
    code: 'Pacific/Tongatapu',
  },
];

const languages = [
  {
    code: 'any',
    name: 'Any Language',
  },
  {
    code: 'en',
    name: 'English',
  },
  {
    code: 'ar',
    name: 'Arabic',
  },
  {
    code: 'zh',
    name: 'Chinese-Mandarin',
  },
  {
    code: 'ca',
    name: 'Catalan',
  },
  {
    code: 'cs',
    name: 'Czech',
  },
  {
    code: 'da',
    name: 'Danish',
  },
  {
    code: 'in',
    name: 'Indonesian',
  },
  {
    code: 'ms',
    name: 'Malaysian',
  },
  {
    code: 'nl',
    name: 'Dutch',
  },
  {
    code: 'fr',
    name: 'French',
  },
  {
    code: 'fi',
    name: 'Finnish',
  },
  {
    code: 'de',
    name: 'German',
  },
  {
    code: 'el',
    name: 'Greek',
  },
  {
    code: 'he',
    name: 'Hebrew',
  },
  {
    code: 'hi',
    name: 'Hindi',
  },
  {
    code: 'hu',
    name: 'Hungarian',
  },
  {
    code: 'it',
    name: 'Italian',
  },
  {
    code: 'ja',
    name: 'Japanese',
  },
  {
    code: 'ko',
    name: 'Korean',
  },
  {
    code: 'no',
    name: 'Norwegian',
  },
  {
    code: 'pl',
    name: 'Polish',
  },
  {
    code: 'pt',
    name: 'Portuguese',
  },
  {
    code: 'ro',
    name: 'Romanian',
  },
  {
    code: 'ru',
    name: 'Russian',
  },
  {
    code: 'es',
    name: 'Spanish',
  },
  {
    code: 'sv',
    name: 'Swedish',
  },
  {
    code: 'gsw',
    name: 'Swiss-German',
  },
  {
    code: 'th',
    name: 'Thai',
  },
  {
    code: 'tl',
    name: 'Filipino',
  },
  {
    code: 'tr',
    name: 'Turkish',
  },
];

const countries = [
  {
    code: 'US',
    name: 'United States',
  },
  {
    code: 'CA',
    name: 'Canada',
  },
  {
    code: 'AF',
    name: 'Afghanistan',
  },
  {
    code: 'AX',
    name: 'Åland Islands',
  },
  {
    code: 'AL',
    name: 'Albania',
  },
  {
    code: 'DZ',
    name: 'Algeria',
  },
  {
    code: 'AS',
    name: 'American Samoa',
  },
  {
    code: 'AD',
    name: 'Andorra',
  },
  {
    code: 'AO',
    name: 'Angola',
  },
  {
    code: 'AI',
    name: 'Anguilla',
  },
  {
    code: 'AQ',
    name: 'Antarctica',
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    code: 'AR',
    name: 'Argentina',
  },
  {
    code: 'AM',
    name: 'Armenia',
  },
  {
    code: 'AW',
    name: 'Aruba',
  },
  {
    code: 'AU',
    name: 'Australia',
  },
  {
    code: 'AT',
    name: 'Austria',
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
  },
  {
    code: 'BS',
    name: 'Bahamas',
  },
  {
    code: 'BH',
    name: 'Bahrain',
  },
  {
    code: 'BD',
    name: 'Bangladesh',
  },
  {
    code: 'BB',
    name: 'Barbados',
  },
  {
    code: 'BY',
    name: 'Belarus',
  },
  {
    code: 'BE',
    name: 'Belgium',
  },
  {
    code: 'BZ',
    name: 'Belize',
  },
  {
    code: 'BJ',
    name: 'Benin',
  },
  {
    code: 'BM',
    name: 'Bermuda',
  },
  {
    code: 'BT',
    name: 'Bhutan',
  },
  {
    code: 'BO',
    name: 'Bolivia, Plurinational State of',
  },
  {
    code: 'BQ',
    name: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    code: 'BW',
    name: 'Botswana',
  },
  {
    code: 'BV',
    name: 'Bouvet Island',
  },
  {
    code: 'BR',
    name: 'Brazil',
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    code: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    code: 'BG',
    name: 'Bulgaria',
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
  },
  {
    code: 'BI',
    name: 'Burundi',
  },
  {
    code: 'CV',
    name: 'Cabo Verde',
  },
  {
    code: 'KH',
    name: 'Cambodia',
  },
  {
    code: 'CM',
    name: 'Cameroon',
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
  },
  {
    code: 'CF',
    name: 'Central African Republic',
  },
  {
    code: 'TD',
    name: 'Chad',
  },
  {
    code: 'CL',
    name: 'Chile',
  },
  {
    code: 'CN',
    name: 'China',
  },
  {
    code: 'CX',
    name: 'Christmas Island',
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  {
    code: 'CO',
    name: 'Colombia',
  },
  {
    code: 'KM',
    name: 'Comoros',
  },
  {
    code: 'CG',
    name: 'Congo',
  },
  {
    code: 'CD',
    name: 'Congo, The Democratic Republic of the',
  },
  {
    code: 'CK',
    name: 'Cook Islands',
  },
  {
    code: 'CR',
    name: 'Costa Rica',
  },
  {
    code: 'CI',
    name: 'Côte d\'Ivoire',
  },
  {
    code: 'HR',
    name: 'Croatia',
  },
  {
    code: 'CU',
    name: 'Cuba',
  },
  {
    code: 'CW',
    name: 'Curaçao',
  },
  {
    code: 'CY',
    name: 'Cyprus',
  },
  {
    code: 'CZ',
    name: 'Czechia',
  },
  {
    code: 'DK',
    name: 'Denmark',
  },
  {
    code: 'DJ',
    name: 'Djibouti',
  },
  {
    code: 'DM',
    name: 'Dominica',
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
  },
  {
    code: 'EC',
    name: 'Ecuador',
  },
  {
    code: 'EG',
    name: 'Egypt',
  },
  {
    code: 'SV',
    name: 'El Salvador',
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    code: 'ER',
    name: 'Eritrea',
  },
  {
    code: 'EE',
    name: 'Estonia',
  },
  {
    code: 'ET',
    name: 'Ethiopia',
  },
  {
    code: 'FK',
    name: 'Falkland Islands (Malvinas)',
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
  },
  {
    code: 'FJ',
    name: 'Fiji',
  },
  {
    code: 'FI',
    name: 'Finland',
  },
  {
    code: 'FR',
    name: 'France',
  },
  {
    code: 'GF',
    name: 'French Guiana',
  },
  {
    code: 'PF',
    name: 'French Polynesia',
  },
  {
    code: 'TF',
    name: 'French Southern Territories',
  },
  {
    code: 'GA',
    name: 'Gabon',
  },
  {
    code: 'GM',
    name: 'Gambia',
  },
  {
    code: 'GE',
    name: 'Georgia',
  },
  {
    code: 'DE',
    name: 'Germany',
  },
  {
    code: 'GH',
    name: 'Ghana',
  },
  {
    code: 'GI',
    name: 'Gibraltar',
  },
  {
    code: 'GR',
    name: 'Greece',
  },
  {
    code: 'GL',
    name: 'Greenland',
  },
  {
    code: 'GD',
    name: 'Grenada',
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
  },
  {
    code: 'GU',
    name: 'Guam',
  },
  {
    code: 'GT',
    name: 'Guatemala',
  },
  {
    code: 'GG',
    name: 'Guernsey',
  },
  {
    code: 'GN',
    name: 'Guinea',
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    code: 'GY',
    name: 'Guyana',
  },
  {
    code: 'HT',
    name: 'Haiti',
  },
  {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
  },
  {
    code: 'VA',
    name: 'Holy See (Vatican City State)',
  },
  {
    code: 'HN',
    name: 'Honduras',
  },
  {
    code: 'HK',
    name: 'Hong Kong',
  },
  {
    code: 'HU',
    name: 'Hungary',
  },
  {
    code: 'IS',
    name: 'Iceland',
  },
  {
    code: 'IN',
    name: 'India',
  },
  {
    code: 'ID',
    name: 'Indonesia',
  },
  {
    code: 'IR',
    name: 'Iran, Islamic Republic of',
  },
  {
    code: 'IQ',
    name: 'Iraq',
  },
  {
    code: 'IE',
    name: 'Ireland',
  },
  {
    code: 'IM',
    name: 'Isle of Man',
  },
  {
    code: 'IL',
    name: 'Israel',
  },
  {
    code: 'IT',
    name: 'Italy',
  },
  {
    code: 'JM',
    name: 'Jamaica',
  },
  {
    code: 'JP',
    name: 'Japan',
  },
  {
    code: 'JE',
    name: 'Jersey',
  },
  {
    code: 'JO',
    name: 'Jordan',
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
  },
  {
    code: 'KE',
    name: 'Kenya',
  },
  {
    code: 'KI',
    name: 'Kiribati',
  },
  {
    code: 'KP',
    name: 'Korea, Democratic People\'s Republic of',
  },
  {
    code: 'KR',
    name: 'Korea, Republic of',
  },
  {
    code: 'KW',
    name: 'Kuwait',
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    code: 'LA',
    name: 'Lao People\'s Democratic Republic',
  },
  {
    code: 'LV',
    name: 'Latvia',
  },
  {
    code: 'LB',
    name: 'Lebanon',
  },
  {
    code: 'LS',
    name: 'Lesotho',
  },
  {
    code: 'LR',
    name: 'Liberia',
  },
  {
    code: 'LY',
    name: 'Libya',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
  },
  {
    code: 'LT',
    name: 'Lithuania',
  },
  {
    code: 'LU',
    name: 'Luxembourg',
  },
  {
    code: 'MO',
    name: 'Macao',
  },
  {
    code: 'MK',
    name: 'Macedonia, Republic of',
  },
  {
    code: 'MG',
    name: 'Madagascar',
  },
  {
    code: 'MW',
    name: 'Malawi',
  },
  {
    code: 'MY',
    name: 'Malaysia',
  },
  {
    code: 'MV',
    name: 'Maldives',
  },
  {
    code: 'ML',
    name: 'Mali',
  },
  {
    code: 'MT',
    name: 'Malta',
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
  },
  {
    code: 'MQ',
    name: 'Martinique',
  },
  {
    code: 'MR',
    name: 'Mauritania',
  },
  {
    code: 'MU',
    name: 'Mauritius',
  },
  {
    code: 'YT',
    name: 'Mayotte',
  },
  {
    code: 'MX',
    name: 'Mexico',
  },
  {
    code: 'FM',
    name: 'Micronesia, Federated States of',
  },
  {
    code: 'MD',
    name: 'Moldova, Republic of',
  },
  {
    code: 'MC',
    name: 'Monaco',
  },
  {
    code: 'MN',
    name: 'Mongolia',
  },
  {
    code: 'ME',
    name: 'Montenegro',
  },
  {
    code: 'MS',
    name: 'Montserrat',
  },
  {
    code: 'MA',
    name: 'Morocco',
  },
  {
    code: 'MZ',
    name: 'Mozambique',
  },
  {
    code: 'MM',
    name: 'Myanmar',
  },
  {
    code: 'NA',
    name: 'Namibia',
  },
  {
    code: 'NR',
    name: 'Nauru',
  },
  {
    code: 'NP',
    name: 'Nepal',
  },
  {
    code: 'NL',
    name: 'Netherlands',
  },
  {
    code: 'NC',
    name: 'New Caledonia',
  },
  {
    code: 'NZ',
    name: 'New Zealand',
  },
  {
    code: 'NI',
    name: 'Nicaragua',
  },
  {
    code: 'NE',
    name: 'Niger',
  },
  {
    code: 'NG',
    name: 'Nigeria',
  },
  {
    code: 'NU',
    name: 'Niue',
  },
  {
    code: 'NF',
    name: 'Norfolk Island',
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    code: 'NO',
    name: 'Norway',
  },
  {
    code: 'OM',
    name: 'Oman',
  },
  {
    code: 'PK',
    name: 'Pakistan',
  },
  {
    code: 'PW',
    name: 'Palau',
  },
  {
    code: 'PS',
    name: 'Palestine, State of',
  },
  {
    code: 'PA',
    name: 'Panama',
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
  },
  {
    code: 'PY',
    name: 'Paraguay',
  },
  {
    code: 'PE',
    name: 'Peru',
  },
  {
    code: 'PH',
    name: 'Philippines',
  },
  {
    code: 'PN',
    name: 'Pitcairn',
  },
  {
    code: 'PL',
    name: 'Poland',
  },
  {
    code: 'PT',
    name: 'Portugal',
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
  },
  {
    code: 'QA',
    name: 'Qatar',
  },
  {
    code: 'RE',
    name: 'Réunion',
  },
  {
    code: 'RO',
    name: 'Romania',
  },
  {
    code: 'RU',
    name: 'Russian Federation',
  },
  {
    code: 'RW',
    name: 'Rwanda',
  },
  {
    code: 'BL',
    name: 'Saint Barthélemy',
  },
  {
    code: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
  },
  {
    code: 'MF',
    name: 'Saint Martin (French part)',
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    code: 'WS',
    name: 'Samoa',
  },
  {
    code: 'SM',
    name: 'San Marino',
  },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
  },
  {
    code: 'SN',
    name: 'Senegal',
  },
  {
    code: 'RS',
    name: 'Serbia',
  },
  {
    code: 'SC',
    name: 'Seychelles',
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
  },
  {
    code: 'SG',
    name: 'Singapore',
  },
  {
    code: 'SX',
    name: 'Sint Maarten (Dutch part)',
  },
  {
    code: 'SK',
    name: 'Slovakia',
  },
  {
    code: 'SI',
    name: 'Slovenia',
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
  },
  {
    code: 'SO',
    name: 'Somalia',
  },
  {
    code: 'ZA',
    name: 'South Africa',
  },
  {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
  },
  {
    code: 'SS',
    name: 'South Sudan',
  },
  {
    code: 'ES',
    name: 'Spain',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
  },
  {
    code: 'SD',
    name: 'Sudan',
  },
  {
    code: 'SR',
    name: 'Suriname',
  },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
  },
  {
    code: 'SZ',
    name: 'Swaziland',
  },
  {
    code: 'SE',
    name: 'Sweden',
  },
  {
    code: 'CH',
    name: 'Switzerland',
  },
  {
    code: 'SY',
    name: 'Syrian Arab Republic',
  },
  {
    code: 'TW',
    name: 'Taiwan, Province of China',
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
  },
  {
    code: 'TZ',
    name: 'Tanzania, United Republic of',
  },
  {
    code: 'TH',
    name: 'Thailand',
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
  },
  {
    code: 'TG',
    name: 'Togo',
  },
  {
    code: 'TK',
    name: 'Tokelau',
  },
  {
    code: 'TO',
    name: 'Tonga',
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    code: 'TN',
    name: 'Tunisia',
  },
  {
    code: 'TR',
    name: 'Turkey',
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    code: 'TV',
    name: 'Tuvalu',
  },
  {
    code: 'UG',
    name: 'Uganda',
  },
  {
    code: 'UA',
    name: 'Ukraine',
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
  },
  {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
  },
  {
    code: 'UY',
    name: 'Uruguay',
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
  },
  {
    code: 'VU',
    name: 'Vanuatu',
  },
  {
    code: 'VE',
    name: 'Venezuela, Bolivarian Republic of',
  },
  {
    code: 'VN',
    name: 'Viet Nam',
  },
  {
    code: 'VG',
    name: 'Virgin Islands, British',
  },
  {
    code: 'VI',
    name: 'Virgin Islands, U.S.',
  },
  {
    code: 'WF',
    name: 'Wallis and Futuna',
  },
  {
    code: 'EH',
    name: 'Western Sahara',
  },
  {
    code: 'YE',
    name: 'Yemen',
  },
  {
    code: 'ZM',
    name: 'Zambia',
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
  },
];

const states = [
  {
    name: 'Alabama',
    abbreviation: 'AL',
  },
  {
    name: 'Alaska',
    abbreviation: 'AK',
  },
  {
    name: 'American Samoa',
    abbreviation: 'AS',
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ',
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR',
  },
  {
    name: 'California',
    abbreviation: 'CA',
  },
  {
    name: 'Colorado',
    abbreviation: 'CO',
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT',
  },
  {
    name: 'Delaware',
    abbreviation: 'DE',
  },
  {
    name: 'District Of Columbia',
    abbreviation: 'DC',
  },
  {
    name: 'Federated States Of Micronesia',
    abbreviation: 'FM',
  },
  {
    name: 'Florida',
    abbreviation: 'FL',
  },
  {
    name: 'Georgia',
    abbreviation: 'GA',
  },
  {
    name: 'Guam',
    abbreviation: 'GU',
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI',
  },
  {
    name: 'Idaho',
    abbreviation: 'ID',
  },
  {
    name: 'Illinois',
    abbreviation: 'IL',
  },
  {
    name: 'Indiana',
    abbreviation: 'IN',
  },
  {
    name: 'Iowa',
    abbreviation: 'IA',
  },
  {
    name: 'Kansas',
    abbreviation: 'KS',
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY',
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA',
  },
  {
    name: 'Maine',
    abbreviation: 'ME',
  },
  {
    name: 'Marshall Islands',
    abbreviation: 'MH',
  },
  {
    name: 'Maryland',
    abbreviation: 'MD',
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA',
  },
  {
    name: 'Michigan',
    abbreviation: 'MI',
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN',
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS',
  },
  {
    name: 'Missouri',
    abbreviation: 'MO',
  },
  {
    name: 'Montana',
    abbreviation: 'MT',
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE',
  },
  {
    name: 'Nevada',
    abbreviation: 'NV',
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH',
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ',
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM',
  },
  {
    name: 'New York',
    abbreviation: 'NY',
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC',
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND',
  },
  {
    name: 'Northern Mariana Islands',
    abbreviation: 'MP',
  },
  {
    name: 'Ohio',
    abbreviation: 'OH',
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK',
  },
  {
    name: 'Oregon',
    abbreviation: 'OR',
  },
  {
    name: 'Palau',
    abbreviation: 'PW',
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA',
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR',
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI',
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC',
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD',
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN',
  },
  {
    name: 'Texas',
    abbreviation: 'TX',
  },
  {
    name: 'Utah',
    abbreviation: 'UT',
  },
  {
    name: 'Vermont',
    abbreviation: 'VT',
  },
  {
    name: 'Virgin Islands',
    abbreviation: 'VI',
  },
  {
    name: 'Virginia',
    abbreviation: 'VA',
  },
  {
    name: 'Washington',
    abbreviation: 'WA',
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV',
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI',
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY',
  },
];

const canadaStates = [
  {
    name: 'Alberta',
    abbreviation: 'AB',
  },
  {
    name: 'British Columbia',
    abbreviation: 'BC',
  },
  {
    name: 'Manitoba',
    abbreviation: 'MB',
  },
  {
    name: 'New Brunswick',
    abbreviation: 'NB',
  },
  {
    name: 'Newfoundland and Labrador',
    abbreviation: 'NL',
  },
  {
    name: 'Northwest Territories',
    abbreviation: 'NT',
  },
  {
    name: 'Nova Scotia',
    abbreviation: 'NS',
  },
  {
    name: 'Nunavut',
    abbreviation: 'NU',
  },
  {
    name: 'Ontario',
    abbreviation: 'ON',
  },
  {
    name: 'Prince Edward Island',
    abbreviation: 'PE',
  },
  {
    name: 'Quebec',
    abbreviation: 'QC',
  },
  {
    name: 'Saskatchewan',
    abbreviation: 'SK',
  },
  {
    name: 'Yukon Territory',
    abbreviation: 'YT',
  },
];

export {
  classTypeMap,
  trainingTypeMap,
  trainingSearchTypeMap,
  countries,
  states,
  canadaStates,
  classIconMap,
  classTypes,
  days,
  startTimes,
  endTimes,
  timezones,
  languages,
  orderings,
  trainingOrderings,
  attendanceTypes,
  trainingAttendanceTypes,
  daysOfWeek,
  dayNumbers,
  numberDays,
};
